import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { UserGroups } from '@shared/models/iuser.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'miq-multiselect',
  templateUrl: './multiselect.component.html',
  styleUrls: ['./multiselect.component.scss'],
  standalone: false,
})
export class MultiselectComponent implements OnChanges, OnDestroy {
  @Input() userGroupOptions: UserGroups[];
  @Input() userListedGroups: UserGroups[] = [];
  @Output()
  public groupChangeEvent = new EventEmitter<any>();
  public groupControl = new UntypedFormControl();

  ngOnChanges() {
    const groups = this.userListedGroups.map(x => x.key);
    this.groupControl.setValue(this.userGroupOptions.filter(group => groups.includes(group.key)) || []);
    this.groupControl.valueChanges.pipe(untilDestroyed(this)).subscribe(res => this.groupChangeEvent.emit(res));
  }
  ngOnDestroy() {
    // REQUIRED by untilDestroyed
  }
}
